// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ActionType } from '../tbs/action-type.js';


export class SwapPlayerSlotAction implements flatbuffers.IUnpackableObject<SwapPlayerSlotActionT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):SwapPlayerSlotAction {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsSwapPlayerSlotAction(bb:flatbuffers.ByteBuffer, obj?:SwapPlayerSlotAction):SwapPlayerSlotAction {
  return (obj || new SwapPlayerSlotAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsSwapPlayerSlotAction(bb:flatbuffers.ByteBuffer, obj?:SwapPlayerSlotAction):SwapPlayerSlotAction {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new SwapPlayerSlotAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

type():ActionType {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : ActionType.LobbySwapPlayerSlot;
}

playerId1():number {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0;
}

playerId2():number {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0;
}

static startSwapPlayerSlotAction(builder:flatbuffers.Builder) {
  builder.startObject(3);
}

static addType(builder:flatbuffers.Builder, type:ActionType) {
  builder.addFieldInt16(0, type, ActionType.LobbySwapPlayerSlot);
}

static addPlayerId1(builder:flatbuffers.Builder, playerId1:number) {
  builder.addFieldInt16(1, playerId1, 0);
}

static addPlayerId2(builder:flatbuffers.Builder, playerId2:number) {
  builder.addFieldInt16(2, playerId2, 0);
}

static endSwapPlayerSlotAction(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createSwapPlayerSlotAction(builder:flatbuffers.Builder, type:ActionType, playerId1:number, playerId2:number):flatbuffers.Offset {
  SwapPlayerSlotAction.startSwapPlayerSlotAction(builder);
  SwapPlayerSlotAction.addType(builder, type);
  SwapPlayerSlotAction.addPlayerId1(builder, playerId1);
  SwapPlayerSlotAction.addPlayerId2(builder, playerId2);
  return SwapPlayerSlotAction.endSwapPlayerSlotAction(builder);
}

unpack(): SwapPlayerSlotActionT {
  return new SwapPlayerSlotActionT(
    this.type(),
    this.playerId1(),
    this.playerId2()
  );
}


unpackTo(_o: SwapPlayerSlotActionT): void {
  _o.type = this.type();
  _o.playerId1 = this.playerId1();
  _o.playerId2 = this.playerId2();
}
}

export class SwapPlayerSlotActionT implements flatbuffers.IGeneratedObject {
constructor(
  public type: ActionType = ActionType.LobbySwapPlayerSlot,
  public playerId1: number = 0,
  public playerId2: number = 0
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  return SwapPlayerSlotAction.createSwapPlayerSlotAction(builder,
    this.type,
    this.playerId1,
    this.playerId2
  );
}
}
